function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import { Table, Form, Button, DatePicker, Select, message, Space, Drawer, Collapse, Skeleton } from 'antd';
import { Container, Row, Col } from 'react-bootstrap';
import Common from './includes/Common';
import dayjs from 'dayjs';
import Moment from 'react-moment';
import moment from 'moment';
import AddCashEntry from './forms/AddCashEntry';
import { CheckCircleFill, ThreeDots } from 'react-bootstrap-icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var PumpReportList = function PumpReportList(_ref) {
  var cashBox = _ref.cashBox,
    refresh = _ref.refresh;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    reportList = _useState2[0],
    setReportList = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    reportArrayData = _useState4[0],
    setReportArrayData = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    agentOptions = _useState6[0],
    setAgentOptions = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isFormLoading = _useState8[0],
    setIsFormLoading = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isNewCashEntryVisible = _useState10[0],
    setIsNewCashEntryVisible = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedTransaction = _useState12[0],
    setSelectedTransaction = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isDataChanged = _useState14[0],
    setIsDataChanged = _useState14[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var cols = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "Date"
    }),
    dataIndex: 'date',
    key: 'date',
    render: function render(text) {
      return /*#__PURE__*/_jsx(Moment, {
        date: text,
        format: "DD/MM/YYYY"
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Agent"
    }),
    dataIndex: 'agent',
    key: 'agent',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "A d\xE9poser"
    }),
    dataIndex: 'total',
    key: 'total',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text.toLocaleString('Fr')
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "D\xE9pos\xE9"
    }),
    dataIndex: 'amount',
    responsive: ['lg', 'md', 'sm'],
    key: 'amount',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text.toLocaleString('Fr')
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Ecart"
    }),
    dataIndex: 'ecart',
    key: 'ecart',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text.toLocaleString('Fr')
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Action"
    }),
    dataIndex: 'action',
    key: 'action',
    render: function render(pr) {
      return /*#__PURE__*/_jsxs(Space, {
        direction: "horizontal",
        children: [pr.status == 0 ? /*#__PURE__*/_jsx(Button, {
          type: "link",
          onClick: function onClick() {
            setSelectedTransaction(pr);
            setIsNewCashEntryVisible(true);
          },
          children: /*#__PURE__*/_jsx("b", {
            children: "ENCAISSER"
          })
        }) : /*#__PURE__*/_jsx(Button, {
          type: "link",
          style: {
            width: '110px'
          },
          disabled: true,
          children: /*#__PURE__*/_jsx(CheckCircleFill, {
            size: 22
          })
        }), /*#__PURE__*/_jsx(Button, {
          type: "link",
          onClick: null,
          children: /*#__PURE__*/_jsx(ThreeDots, {
            size: 26
          })
        })]
      });
    }
  }];
  var onFinish = function onFinish(values) {
    setIsFormLoading(true);
    var request = values.agent_id == 0 ? axios.get("".concat(Common.baseApiUrl, "getpumpreports/").concat(Common.currentUser.id, "/").concat(moment(values.period[0].$d).format(), "/").concat(moment(values.period[1].$d).format())) : axios.get("".concat(Common.baseApiUrl, "getpumpreports/").concat(values.agent_id, "/").concat(Common.currentUser.id, "/").concat(moment(values.period[0].$d).format(), "/").concat(moment(values.period[1].$d).format()));
    request.then(function (response) {
      if (response.data.status == 200) {
        setReportArrayData([]);
        setReportList(response.data.reports);
        response.data.reports.forEach(function (r) {
          setReportArrayData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: r.id,
              action: r,
              date: r.created_at,
              agent: "".concat(r.agent.prenom, " ").concat(r.agent.nom),
              indexStart: r.indexStart,
              indexEnd: r.indexEnd,
              total: (r.indexEnd - r.indexStart) * r.product.base_price,
              amount: r.total_cash + r.total_coupon,
              ecart: r.total_cash + r.total_coupon - (r.indexEnd - r.indexStart) * r.product.base_price
            }]);
          });
        });
      } else {
        message.error({
          content: 'Une erreur est survenue',
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  useEffect(function () {
    setIsDataChanged(false);
    axios.all([axios.get(Common.baseApiUrl + "getplatformusers/" + Common.currentUser.id), axios.get("".concat(Common.baseApiUrl, "getpumpreports/").concat(Common.currentUser.id, "/").concat(moment().startOf('day').format(), "/").concat(moment().endOf('day').format()))]).then(function (response) {
      if (response[0].data.status == 200) {
        setAgentOptions(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            label: 'Tous les agents',
            value: 0
          }]);
        });
        response[0].data.users.filter(function (u) {
          return u.role == 401;
        }).forEach(function (u) {
          setAgentOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: u.prenom + " " + u.nom,
              value: u.id
            }]);
          });
        });
        form.setFieldsValue({
          agent_id: 0
        });
      } else {
        message.error({
          content: 'Une erreur est survenue',
          delay: 4
        });
      }
      if (response[1].data.status == 200) {
        setReportArrayData([]);
        setReportList(response[1].data.reports);
        response[1].data.reports.forEach(function (r) {
          setReportArrayData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: r.id,
              date: r.created_at,
              action: r,
              agent: "".concat(r.agent.prenom, " ").concat(r.agent.nom),
              indexStart: r.indexStart,
              indexEnd: r.indexEnd,
              total: (r.indexEnd - r.indexStart) * r.product.base_price,
              amount: r.total_cash + r.total_coupon,
              ecart: r.total_cash + r.total_coupon - (r.indexEnd - r.indexStart) * r.product.base_price
            }]);
          });
        });
      } else {
        message.error({
          content: 'Une erreur est survenue',
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue ',
        delay: 5
      });
    })["finally"](function () {});
  }, [isDataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Collapse, {
      ghost: true,
      items: [{
        key: '1',
        label: /*#__PURE__*/_jsx("b", {
          children: " Filtrer"
        }),
        children: /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsx(Form, {
            onFinish: onFinish,
            form: form,
            size: "large",
            children: /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 4,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "period",
                  rules: [{
                    required: true,
                    message: 'Ce champ est obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(RangePicker, {
                    showTime: true,
                    format: "DD/MM/YYYY HH:mm:ss",
                    presets: [{
                      label: 'Hier',
                      value: dayjs().add(-1, 'd')
                    }, {
                      label: "Aujourdh'hui",
                      value: dayjs().add(0, 'd')
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 4,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "agent_id",
                  rules: [{
                    required: true,
                    message: 'Ce champ est obligatoire'
                  }],
                  children: /*#__PURE__*/_jsx(Select, {
                    options: agentOptions
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 2,
                md: 2,
                children: /*#__PURE__*/_jsx(Form.Item, {
                  children: /*#__PURE__*/_jsx(Button, {
                    loading: isFormLoading,
                    type: "primary",
                    htmlType: "submit",
                    children: /*#__PURE__*/_jsx("b", {
                      children: "RECHERCHE"
                    })
                  })
                })
              })]
            })
          })
        })
      }]
    }), /*#__PURE__*/_jsx(Table, {
      columns: cols,
      dataSource: reportArrayData,
      bordered: true,
      size: "small"
    }), selectedTransaction != null && /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsx("b", {
        children: "ENCAISSEMENT RECETTE"
      }),
      width: "380px",
      destroyOnClose: true,
      open: isNewCashEntryVisible,
      onClose: function onClose() {
        setIsNewCashEntryVisible(false);
      },
      children: /*#__PURE__*/_jsx(AddCashEntry, {
        transaction: selectedTransaction,
        cashBox: cashBox,
        handler: function handler() {
          refresh();
          setIsNewCashEntryVisible(false);
          setIsDataChanged(true);
          refresh();
          message.success({
            content: 'Opération réussie !',
            delay: 4
          });
        }
      })
    })]
  });
};
export default PumpReportList;